<template>
  <v-navigation-drawer
    v-model="utilsDrawer"
    overlay-color="primary"
    overlay-opacity="0.97"
    color="primary"
    fixed
    right
    temporary
    dark>
    
    <v-row class="ma-0 bg-white" justify="start">
      <v-col cols="auto">
        <v-btn
          elevation="2"
          icon
          class="bg-primary"
          dark
          small
          @click="utilsDrawer=false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row class="ma-0" justify="start">
      <v-col cols="12" class="pa-0">
        <UtilsPanelStatic />
      </v-col>
    </v-row>

  </v-navigation-drawer>
</template>

<script>
import UtilsPanelStatic from './UtilsPanelStatic.vue'

export default {
  components: {
    UtilsPanelStatic
  },
  data() {
    return {
      utilsDrawer: false
    }
  },
  methods: {
    utilsToggle() {
      try {
        this.utilsDrawer = !this.utilsDrawer
      } catch (error) {
        console.error('Error en utilsToggle:', error);
      }
    },
  },
  mounted() {
    if (this.$root && typeof this.$root.$on === 'function') {
      this.$root.$on('utilsToggle', this.utilsToggle);
    }
  },
  beforeDestroy() {
    if (this.$root && typeof this.$root.$off === 'function') {
      this.$root.$off('utilsToggle', this.utilsToggle);
    }
  }
}
</script>

<style lang="scss">
.bg-white {
  background-color: white;
}
</style>